<div style="margin: 10px;">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer">
            <span   [ngClass]="menu_now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>
    <div style="padding:30px;margin-left:10px ;" *ngIf="menu_now=='1'">

        <div style="display: flex;">
            <app-date [time]="time" [timeset]="timeset" (rangeSelected)="handleRangeSelected($event)"></app-date>
            
            <select class="form-control" style="width: 160px;display: inline-block;margin-bottom: 2%;margin-right: 1%;" [(ngModel)]="search_benefits" (change)="default();init_list()">
                <option *ngFor="let item of benefits_list" [ngValue]="item.id">{{item.name}}</option>
            </select>

            <select class="form-control" style="width: 160px;display: inline-block;margin-bottom: 2%;margin-right: 1%;" [(ngModel)]="search_top_up" (change)="default();init_list()">
                <option *ngFor="let item of top_up_list" [ngValue]="item.id">{{item.name}}</option>
            </select>

            <h4 style="margin-right: 3%;">
                總儲值次數：{{recharge_num}}
            </h4>

            <h4>
                總儲值金額：{{recharge}}
            </h4>

        </div>
        <app-table-v2  *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent" [data]="data" (sortdata)="handlesortdata($event)">  
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'status'">
                    <div [ngSwitch]="post.val.status">
                        <div *ngSwitchCase="-4">派發失敗</div>
                        <div *ngSwitchCase="-1">過期</div>
                        <div *ngSwitchCase="0">未派</div>
                        <div *ngSwitchCase="1">已派</div>
                    </div>
                </div>
                <div *ngIf="post.key == 'sms_status'">
                    <div [ngSwitch]="post.val.sms_status">
                        <div *ngSwitchCase="0">未通知</div>
                        <div *ngSwitchCase="1">已推播通知</div>
                        <div *ngSwitchCase="2">已簡訊通知</div>
                    </div>
                </div>
                <div *ngIf="post.key == 'recharge_num'">
                    <div [ngSwitch]="true">
                        <!-- 负数的情况 -->
                        <div *ngSwitchCase="toNumber(post.val.recharge_num) < 0">{{toNumber(post.val.recharge_num)}}</div>
                        <!-- 默认情况 -->
                        <div *ngSwitchDefault>{{ post.val.recharge_num }}</div>
                    </div>
                </div>
                <div *ngIf="post.key == 'recharge'">
                    <div [ngSwitch]="true">
                        <!-- 负数的情况 -->
                        <div *ngSwitchCase="toNumber(post.val.recharge) < 0">{{toNumber(post.val.recharge_num)}}</div>
                        <!-- 默认情况 -->
                        <div *ngSwitchDefault>{{ post.val.recharge }}</div>
                    </div>
                </div>
            </ng-template>  
        </app-table-v2>
    </div>
    <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
    <div *ngIf="data.length==0">無資料</div>
</div>
<app-spinner [loading]="loading"></app-spinner>


